import { lazy } from "react";
import reducer from "./state/reducers";
import { getStore } from "@AppRedux/store";
import checkAuth from "@Utils/checkAuth";

const store = getStore();

const onboardingList = lazy(() =>
  import("./OnboardingList").then(async (module) => {
    await checkAuth();
    const auth = getStore().getState().auth;
    if (auth.isAuthenticated) {
      store.injectReducer("onboardingList", reducer.listReducer);
      return module;
    }
  })
);

const onboardingAdd = lazy(() =>
  import("./OnboardingAdd").then(async (module) => {
    await checkAuth();
    const auth = getStore().getState().auth;
    if (auth.isAuthenticated) {
      store.injectReducer("onboardingAdd", reducer.addReducer);
      return module;
    }
  })
);

const onboardingDetail = lazy(() =>
  import("./OnboardingDetails").then(async (module) => {
    await checkAuth();
    const auth = getStore().getState().auth;
    if (auth.isAuthenticated) {
      store.injectReducer("onboardingDetail", reducer.detailReducer);
      return module;
    }
  })
);


const onboardingRoutes = [
    {
        label: "Onboarding",
        path: '/HRAutomation/Onboarding',
        menuName: 'hrAutomation',
        component: onboardingList,
        icon: 'fa-user',
        exact: true,
        showNav: true,
        public: true,
    },
    {
        label: "Onboarding",
        path: '/HRAutomation/Onboarding/OnboardingAdd',
        component: onboardingAdd,
        icon: 'fa-user',
        exact: true,
        showNav: false,
        public: true,
    },
    {
      label: "Onboarding",
      path: '/HRAutomation/Onboarding/:mode/:onboardingTrainingID',
      component: onboardingDetail,
      icon: 'fa-user',
      exact: true,
      showNav: false,
      public: true,
    }
  
]

export default onboardingRoutes;